export default __webpack_public_path__ + "static/media/drag-icon.d42b4a88.svg";